<template>
  <div class="fixed bottom-0 left-2 z-50 p-4 flex flex-col gap-3">
    <div
      v-for="item in items"
      :key="item.id"
      class="w-72 bg-white border border-neutral-100 rounded-lg shadow-lg p-4"
      role="status"
      aria-live="polite"
    >
      <div class="flex items-start gap-3">
        <component :is="iconFor(item.type)" class="w-6 h-6" :class="iconClass(item.type)" />
        <div class="flex-1">
          <div class="text-sm font-semibold text-neutral-950">{{ titleFor(item.type) }}</div>
          <div class="text-sm text-neutral-600 mt-0.5">{{ item.message }}</div>
        </div>
        <button
          type="button"
          class="text-neutral-450 hover:text-neutral-950 transition-colors"
          @click="$notify.remove(item.id)"
          aria-label="Zamknij"
        >
          <XMarkIcon class="w-5 h-5" />
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import {
  CheckCircleIcon,
  XCircleIcon,
  ExclamationTriangleIcon,
  InformationCircleIcon,
  XMarkIcon,
} from '@heroicons/vue/24/outline';

export default {
  name: 'Snackbar',
  components: {
    CheckCircleIcon,
    XCircleIcon,
    ExclamationTriangleIcon,
    InformationCircleIcon,
    XMarkIcon,
  },
  computed: {
    items() {
      return this.$notify?.state?.items ?? [];
    },
  },
  methods: {
    titleFor(type) {
      switch (type) {
        case 'success':
          return 'Sukces';
        case 'error':
          return 'Błąd';
        case 'warning':
          return 'Uwaga';
        default:
          return 'Informacja';
      }
    },
    iconFor(type) {
      switch (type) {
        case 'success':
          return CheckCircleIcon;
        case 'error':
          return XCircleIcon;
        case 'warning':
          return ExclamationTriangleIcon;
        default:
          return InformationCircleIcon;
      }
    },
    iconClass(type) {
      switch (type) {
        case 'success':
          return 'text-success-800';
        case 'error':
          return 'text-danger-850';
        case 'warning':
          return 'text-primary-950';
        default:
          return 'text-primary-950';
      }
    },
  },
};
</script>
